import { ActionReducerMapBuilder, createSlice } from '@reduxjs/toolkit'
import { withLoadingReducer } from 'utils/reducerHandler'
import { ReplenishmentTaskV3InitialStateType } from 'features/SupplyOrder/@types/ReplenishmentV3'
import {
  SLICE_NAME,
  assignReplenishmentLetdownStaff,
  fetchReplenishmentLetdownTask,
  fetchStaffList,
} from './thunk'

const initialState: ReplenishmentTaskV3InitialStateType = {
  isLoading: false,
  data: [],
  selectedReplenishToEdit: null,
  staffList: [],
}

const replenishmentTaskSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    resetReplenishmentTaskV3State: () => initialState,
    setSelectedReplenishToEdit: (state, action) => {
      state.selectedReplenishToEdit = action.payload
    },
  },
  extraReducers: withLoadingReducer(
    (builder: ActionReducerMapBuilder<ReplenishmentTaskV3InitialStateType>) => {
      builder.addCase(fetchReplenishmentLetdownTask.fulfilled, (state, action) => {
        state.data = action.payload.data
      })
      builder.addCase(fetchStaffList.fulfilled, (state, action) => {
        state.staffList = action.payload.data
      })
    },
    [fetchReplenishmentLetdownTask, assignReplenishmentLetdownStaff],
  ),
})

export const { resetReplenishmentTaskV3State, setSelectedReplenishToEdit } =
  replenishmentTaskSlice.actions
export default replenishmentTaskSlice.reducer
